import React, { useState, ChangeEvent, useEffect, useCallback } from "react";
import Header from "../../components/header/header";
import Pagination from "react-bootstrap/Pagination";
import Accordion from "react-bootstrap/Accordion";
import { Link, useLocation } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./servicosOrdem.css";
import { useNavigate, useParams } from "react-router-dom";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPlus, faArrowLeft, faPencil, faTrashCan, faFilter, faSearch, faGear, faGears, faBoxesStacked, faUsers} from "@fortawesome/free-solid-svg-icons";
import { getServicosOrdem } from "../../services/api_servicos_ordem_servicos";
import {getServicoOrdemDelete, getServicosOrdemById} from "../../services/api_cadastro_servico_ordem";
import Swal from "sweetalert2";

import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import { Permissions } from "../../hooks/Permission/permission";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: blue[600],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const ServicosOrdemListage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const idOrdem = location.state?.idOrdem || sessionStorage.getItem("idOrdem");
  const idPlano = location.state?.idPlano || sessionStorage.getItem("idPlano");
  const itemsPerPageOptions = [5, 10, 20, 50];
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [dados, setDados] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  //console.log(idOrdem);
  const POLLING_INTERVAL = 30000;

  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (idOrdem) {
      sessionStorage.setItem("idOrdem", idOrdem);
    }
    if (idPlano) {
      sessionStorage.setItem("idPlano", idPlano);
    }
  }, [idPlano, idOrdem]);

  const fetchData = useCallback(async () => {
    try {
      const response = await getServicosOrdem();
      //console.log("informações serviços ordem", response);
      setDados(
        response.data.ServicosOrdem.filter(
          (servicoOrdem) => servicoOrdem.id_ordem_servico === idOrdem
        )
      );
      setLoading(false);
    } catch (error) {
      console.error("Erro ao obter dados:", error);
    }
  }, [])

  useEffect(() => {
    fetchData();
    const interval = setInterval(() => {
      fetchData();
    }, POLLING_INTERVAL);

    return () => clearInterval(interval);
  }, [fetchData]);

  useEffect(() => {
    const filterData = () => {
      if (dados && dados.length > 0) {
        const filtered = dados.filter(
          (item) =>
            (item.descricao && item.descricao.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.id && item.id.toString().includes(searchTerm))||
            (item.servico?.descricao && item.servico?.descricao.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.setor_executante?.descricao && item.setor_executante?.descricao.toLowerCase().includes(searchTerm.toLowerCase()))
        );

        setFilteredData(filtered);
        setCurrentPage(1);
      } else {
        // Caso os dados estejam vazios ou undefined, limpar os dados filtrados
        setFilteredData([]);
        setCurrentPage(1);
      }
    };

    filterData();
  }, [searchTerm, dados]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = searchTerm
    ? filteredData
      ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
      : []
    : dados
    ? dados.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = Math.ceil(
    (searchTerm
      ? filteredData
        ? filteredData.length
        : 0
      : dados
      ? dados.length
      : 0) / itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  // const handleGoToEdit = (id, idPlano) => {
  //   navigate(`/execucao-cadastrar`, {
  //     state: { id, idOrdem: idOrdem, idPlano: idPlano },
  //   });
  // };

  const handleDeleteModal = (id) => {
    Swal.fire({
      title: "Tem certeza de que deseja inativar o registro?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#808B96",
      confirmButtonText: "Inativar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const response = await getServicoOrdemDelete(id);
          //console.log(response);
          if (response && response.data) {
            //console.log(response);
            const updatedData = dados.filter((item) => item.id !== id);
            setDados(updatedData);
            setShowModal(false);
            setLoading(false);
            return true;
          } else if (response.response.status === 422) {
            if (response.response.data.mensagem) {
              const mensagem = response.response.data.mensagem;
              return Swal.showValidationMessage(`${mensagem}`);
            } else if (response.response.data.errors) {
              const error = response.response.data.errors;
              return Swal.showValidationMessage(`Erro: ${error}`);
            }
          }
        } catch (error) {
          return Swal.showValidationMessage(`
          Erro: ${error}
        `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value) {
          Swal.fire({
            title: "Inativado!",
            text: "O registro foi inativado com sucesso.",
            icon: "success",
            timer: 2500,
          });
        }
      }
    });
  };

  const handleStatus = (status) => {
    switch (status) {
      case "0":
        return "Pendente";
      case "1":
        return "Executado";
      case "2":
        return "Cancelado";
      default:
        return "Status desconhecido";
    }
  };

  const handleProgramado = (programado) => {
    switch (programado) {
      case 0:
        return "Não";
      case 1:
        return "Sim";
      default:
        break;
    }
  };

  const renderPaginationItems = () => {
    const paginationItems = [];

    paginationItems.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );

    paginationItems.push(
      <Pagination.Item
        key={1}
        active={1 === currentPage}
        onClick={() => handlePageChange(1)}
      >
        {1}
      </Pagination.Item>
    );

    if (currentPage > 3) {
      paginationItems.push(
        <Pagination.Ellipsis key="ellipsis-start" disabled />
      );
    }

    for (
      let i = Math.max(2, currentPage - 2);
      i <= Math.min(totalPages - 1, currentPage + 2);
      i++
    ) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages - 2) {
      paginationItems.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    if (totalPages > 1) {
      paginationItems.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === currentPage}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    paginationItems.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );

    return paginationItems;
  };

  function ExpansibleRow(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow
          className="table-row"
          sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell />
          <TableCell>{row.id}</TableCell>
          <TableCell>{row.descricao}</TableCell>
          <TableCell>{handleProgramado(row.programado)}</TableCell>
          <TableCell>{handleStatus(row.status)}</TableCell>
          <TableCell>{row.setor_executante?.descricao}</TableCell>
          <TableCell>{row.servico?.descricao}</TableCell>
          <TableCell style={{justifyContent: 'flex-end', borderBottom: "none"}} align="left" className="d-flex">
            <Permissions
              requiredPermissions={[
                { entidade: 'PessoaServicoOrdem', actions: ['view'] }
              ]}
            >
              <button className="btn btn-sm text-dark"
               disabled = {row.deleted_at !== null}
              >
                <Link
                  state={{
                    idServicoOrdem: row.id,
                    idSetorExecutante: row.id_setor_executante,
                    idOrdem:idOrdem
                  }}
                  to={`/pessoas-ordem`}
                  className="ml-auto"
                >
                  <FontAwesomeIcon icon={faUsers} size="1x" color={row.deleted_at !== null ? "gray" : "#1E90FF"} />
                </Link>
              </button>
            </Permissions>
            <Permissions
              requiredPermissions={[
                { entidade: 'MateriaisServico', actions: ['view'] }
              ]}
            >
              <button className="btn btn-sm text-dark"
                 disabled = {row.deleted_at !== null}
              >
                <Link
                  state={{ 
                    idServicoOrdem: row.id,
                    idOrdem:idOrdem,
                    idPlano:idPlano
                   }}
                  to={`/materiais-servico`}
                  className="ml-auto"
                >
                  <FontAwesomeIcon
                    icon={faBoxesStacked}
                    size="1x"
                    color={row.deleted_at !== null ? "gray" : "#1E90FF"}
                  />
                </Link>
              </button>
            </Permissions>
            <Permissions 
              requiredPermissions={[
                { entidade: 'ServicosOrdem', actions: ['view'] }
              ]}
            >
              <button className="btn btn-white text-dark"
                 disabled = {row.deleted_at !== null}
              >
                <Link
                  state={{ id: row.id, idOrdem, idPlano: row.id_plano }}
                  to={"/execucao-cadastrar"}
                >
                  <FontAwesomeIcon icon={faPencil} size="1x" color={row.deleted_at !== null ? "gray" : "#1E90FF"} />
                </Link>
              </button>
            </Permissions>
            <Permissions
              requiredPermissions={[
                { entidade: 'ServicosOrdem', actions: ['delete'] }
              ]}
            >
              <button
                className="btn btn-white text-dark"
                onClick={() => handleDeleteModal(row.id)}
                disabled={
                  row.ordem_servico.situacao === "2" ||
                  row.ordem_servico.situacao === "3" ? true : false  ||
                  row.deleted_at !== null 
                }
              >
                <FontAwesomeIcon icon={faTrashCan} size="1x" color={ 
                  row.ordem_servico.situacao === "2" ||
                  row.ordem_servico.situacao === "3" ? true : false ||
                  row.deleted_at !== null ? 
                  "gray":"#F08080"} />
              </button>
            </Permissions>

            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={11}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <p>
                  <strong>Descrição: </strong> {row.descricao}
                </p>
                <p>
                  <strong>Programado: </strong>
                  {handleProgramado(row.programado)}
                </p>
                <p>
                  <strong>Status: </strong> {handleStatus(row.status)}
                </p>
                <p>
                  <strong>Setor Executante: </strong>
                  {`${row.id_setor_executante} - ${row.setor_executante?.descricao}`}
                </p>
                <p>
                  <strong>Serviço: </strong>{" "}
                  {`${row.id_servico} - ${row.servico?.descricao}`}
                </p>
                <p>
                  <strong>Ordem de Serviço: </strong>{" "}
                  {`${row.id_ordem_servico} - ${row.ordem_servico?.solicitacao}`}
                </p>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <Header title="Serviços / Listagem de Ordens de Serviço / Execução" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        <div className="mb-3">
          <div className="mt-1 mb-3 mt-3">
              <Link to={`/ordens-servico`}>
                <button className="btn btn-light text-dark">
                  <FontAwesomeIcon icon={faArrowLeft} size="1x" color="#black" />
                </button>
              </Link>
            <Permissions
            requiredPermissions={[
              { entidade: 'ServicosOrdem', actions: ['store'] }
            ]}
            >
              <Link state={{ idOrdem }} to={`/execucao-cadastrar`}>
                <button className="btn btn-light text-dark">
                  <FontAwesomeIcon icon={faPlus} size="1x" color="#006400" />
                </button>
              </Link>
            </Permissions>
          </div>

          {isLoading ? (
            <></>
          ) : (
            <>
              <Row>
                <Col md={2} className="mb-3">
                  <Form.Group className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faFilter}
                      size="1x"
                      color="#000000"
                      className="mr-2"
                    />

                    <Form.Control
                      as="select"
                      value={itemsPerPage}
                      onChange={handleItemsPerPageChange}
                      className="ml-2"
                    >
                      {itemsPerPageOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3} className="mb-3 ml-auto">
                  <Form.Group className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faSearch}
                      size="1x"
                      color="#000000"
                      className="mr-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="Digite para pesquisar"
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="ml-2"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </div>

        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            <div className="mt-5 mb-3 text-center">
              <h6>{`Serviços (Ordem #${idOrdem})`}</h6>
            </div>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell />
                    <StyledTableCell>ID</StyledTableCell>
                    <StyledTableCell>Descrição</StyledTableCell>
                    <StyledTableCell>Programado</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Setor Executante</StyledTableCell>
                    <StyledTableCell>Serviço</StyledTableCell>
                    {/*onde cadastro os materiais usados no plano*/}
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItems.map((item) => (
                    <ExpansibleRow key={item.id} row={item} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Pagination className="mt-4">{renderPaginationItems()}</Pagination>
          </>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
        isQuestion={modalContent.isQuestion}
        questionAction={modalContent.qFunc}
      />
    </>
  );
};

export default ServicosOrdemListage;
